import { render, staticRenderFns } from "./BCSwitch.vue?vue&type=template&id=7b36b33b&scoped=true"
import script from "./BCSwitch.vue?vue&type=script&lang=js"
export * from "./BCSwitch.vue?vue&type=script&lang=js"
import style0 from "./BCSwitch.vue?vue&type=style&index=0&id=7b36b33b&prod&scoped=true&lang=css"
import style1 from "./BCSwitch.vue?vue&type=style&index=1&id=7b36b33b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b36b33b",
  null
  
)

export default component.exports